import { BodyLarge } from '@npco/zeller-design-system'
import styled from 'styled-components'

import { BREAKPOINT } from 'styles/breakpoints'
import {
  StyledAsideBox,
  StyledContent as Content,
} from 'layouts/AuthLayout/AuthLayout.styled'
import { LogoCorner as Logo } from 'components/LogoCorner'
import { StyledLogoCornerWrapper } from 'components/LogoCorner/LogoCorner.styled'

export const StyledContent = styled(Content)`
  min-height: unset;
  align-items: center;
`

export const StyledLogo = styled(Logo)`
  ${StyledLogoCornerWrapper} {
    top: 2rem;
  }
`

export const StyledText = styled(BodyLarge)`
  color: ${({ theme }) => theme.colors.GREY_250};
  margin: 0;
`

export const StyledTextWrapper = styled.div`
  min-height: 3.5rem;
  margin-top: 2.5rem;
  text-align: center;
`

export const StyledAside = styled(StyledAsideBox)`
  display: none;

  @media screen and (min-width: ${BREAKPOINT.XS}px) {
    display: block;
    width: 33%;
  }
`
